










































import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { Tooltip } from 'element-ui';
import { namespace } from 'vuex-class';

const StatisticAction = namespace('desk/statistic').Action;

@Component({
  components: {
    [Tooltip.name]: Tooltip
  }
})

/**
 * 创作-管理方卡片
 */
export default class AcgnStatisticStaffCardM extends Vue {
  public name: string = 'AcgnStatisticStaffCardM';

  @Prop({ default: null }) public userId: number | null; // 成员id
  @Prop({ default: null }) public comicId: number | null; // 项目id

  // 1：员工 2：项目
  @Prop({ default: 1 }) public routeType: number; // 用于区分数字点击跳转明细页面

  @StatisticAction private getUserStatistics: any;

  private cardData: any = {};

  // 1：员工 2：项目
  private detailRoute: any = {
    1: 'desk-statisticStaffManagerDetail',
    2: 'desk-statisticDetailComicDetail'
  };

  private async created() {
    this.search();
  }

  private async search() {
    this.cardData = (await this.getUserStatistics({
      user_id: this.userId,
      project_id: this.comicId
    })).result;
  }

  @Watch('userId')
  private userIdChange() {
    this.search();
  }

  private goDetail() {
    const name = this.detailRoute[this.routeType];
    const params: any = {};
    if (this.comicId) {
      params.id = this.comicId;
    }
    if (this.userId) {
      params.userid = this.userId;
    }
    this.$router.push({ name, params });
  }
}
